/*!
 * 
 *
 * 	This file is auto generated by webpack.
 * 	Do not edit this file directly.
 *
 *
 */
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 525:
/***/ (function() {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var VueSearchSelect = function (_HTMLElement) {
  function VueSearchSelect() {
    var _this;
    _classCallCheck(this, VueSearchSelect);
    _this = _callSuper(this, VueSearchSelect);
    _this.vueInstance = null;
    _this.clickOutsideHandler = null;
    _this._isDisabled = false;
    return _this;
  }
  _inherits(VueSearchSelect, _HTMLElement);
  return _createClass(VueSearchSelect, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      requestAnimationFrame(function () {
        _this2.initializeVueApp();
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.clickOutsideHandler) {
        document.removeEventListener('click', this.clickOutsideHandler);
      }
      if (this.vueInstance) {
        this.vueInstance.unmount();
        this.vueInstance = null;
      }
    }
  }, {
    key: "initializeVueApp",
    value: function initializeVueApp() {
      var _this3 = this;
      if (typeof Vue === 'undefined') return;
      var mountPoint = this;
      var optionsData = [];
      var dataScript = this.querySelector('#vueSearchSelectData');
      if (dataScript) {
        try {
          optionsData = JSON.parse(dataScript.textContent.trim());
        } catch (error) {
          console.error('Error parsing select options:', error);
        }
      }
      this.clickOutsideHandler = function (event) {
        if (!_this3.vueInstance || !_this3.vueInstance.isOpen) return;
        if (!mountPoint.contains(event.target)) {
          _this3.vueInstance.isOpen = false;
        }
      };
      document.addEventListener('click', this.clickOutsideHandler);
      var VueSearchSelectApp = Vue.createApp({
        data: function data() {
          return {
            isOpen: false,
            searchQuery: '',
            selectedValue: '',
            selectedLabel: '',
            options: optionsData,
            placeholder: mountPoint.getAttribute('data-placeholder')
          };
        },
        computed: {
          filteredOptions: function filteredOptions() {
            if (!this.searchQuery) return this.options;
            var query = this.searchQuery.toLowerCase();
            return this.options.filter(function (opt) {
              return opt.label.toLowerCase().includes(query);
            });
          },
          displayText: function displayText() {
            return this.selectedLabel || this.placeholder;
          }
        },
        methods: {
          toggleDropdown: function toggleDropdown() {
            var _this4 = this;
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
              this.$nextTick(function () {
                var _this4$$refs$searchIn;
                (_this4$$refs$searchIn = _this4.$refs.searchInput) === null || _this4$$refs$searchIn === void 0 || _this4$$refs$searchIn.focus();
              });
            }
          },
          selectOption: function selectOption(option) {
            this.selectedValue = option.value;
            this.selectedLabel = option.label;
            this.isOpen = false;
            this.searchQuery = '';
            mountPoint.dispatchEvent(new CustomEvent('vue-search-select:change', {
              detail: {
                value: option.value,
                label: option.label
              },
              bubbles: true
            }));
          },
          clearSearch: function clearSearch() {
            this.searchQuery = '';
          },
          updateOptions: function updateOptions(newOptions) {
            this.options = newOptions;
            this.selectedValue = '';
            this.selectedLabel = '';
            this.searchQuery = '';
            this.isOpen = false;
          },
          resetSelection: function resetSelection() {
            this.selectedValue = '';
            this.selectedLabel = '';
            this.searchQuery = '';
            this.isOpen = false;
          }
        },
        mounted: function mounted() {
          var initialValue = mountPoint.getAttribute('data-value');
          if (initialValue) {
            var option = this.options.find(function (opt) {
              return opt.value === initialValue;
            });
            if (option) {
              this.selectedValue = option.value;
              this.selectedLabel = option.label;
            }
          }
        }
      });
      VueSearchSelectApp.config.compilerOptions.delimiters = ['${', '}'];
      try {
        this.vueInstance = VueSearchSelectApp.mount(mountPoint);
        if (this._isDisabled) {
          this._applyDisabledStyles();
        }
      } catch (error) {
        console.error('Error mounting VueSearchSelect:', error);
        this.disconnectedCallback();
      }
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(newOptions) {
      if (this.vueInstance) {
        this.vueInstance.updateOptions(newOptions);
      }
    }
  }, {
    key: "resetSelection",
    value: function resetSelection() {
      if (this.vueInstance) {
        this.vueInstance.resetSelection();
      }
    }
  }, {
    key: "enable",
    value: function enable() {
      this._isDisabled = false;
      this.removeAttribute('disabled');
      this._applyDisabledStyles();
    }
  }, {
    key: "disable",
    value: function disable() {
      this._isDisabled = true;
      this.setAttribute('disabled', '');
      this._applyDisabledStyles();
    }
  }, {
    key: "_applyDisabledStyles",
    value: function _applyDisabledStyles() {
      var wrapper = this.querySelector('.vue-search-select');
      if (wrapper) {
        wrapper.style.opacity = this._isDisabled ? '0.5' : '1';
        wrapper.style.pointerEvents = this._isDisabled ? 'none' : 'auto';
      }
    }
  }]);
}(_wrapNativeSuper(HTMLElement));
customElements.define('vue-search-select', VueSearchSelect);

/***/ }),

/***/ 913:
/***/ (function() {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var WatchStrapSelector = function (_HTMLElement) {
  function WatchStrapSelector() {
    var _this;
    _classCallCheck(this, WatchStrapSelector);
    _this = _callSuper(this, WatchStrapSelector);
    _this.vueInstance = null;
    _this.clickOutsideHandler = null;
    return _this;
  }
  _inherits(WatchStrapSelector, _HTMLElement);
  return _createClass(WatchStrapSelector, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      requestAnimationFrame(function () {
        _this2.initializeVueApp();
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.clickOutsideHandler) {
        document.removeEventListener('click', this.clickOutsideHandler);
      }
      if (this.vueInstance) {
        this.vueInstance.unmount();
        this.vueInstance = null;
      }
    }
  }, {
    key: "initializeVueApp",
    value: function initializeVueApp() {
      var _this3 = this;
      if (typeof Vue === 'undefined') return;
      var mountPoint = this;
      var strapData = [];
      var dataScript = this.querySelector('#watchStrapData');
      if (dataScript) {
        try {
          strapData = JSON.parse(dataScript.textContent.trim());
        } catch (error) {
          console.error('Error parsing watch strap data:', error);
        }
      }
      this.clickOutsideHandler = function (event) {
        if (!_this3.vueInstance) return;
        if (!mountPoint.contains(event.target)) {
          _this3.vueInstance.closeAllDropdowns();
        }
      };
      document.addEventListener('click', this.clickOutsideHandler);
      var WatchStrapApp = Vue.createApp({
        data: function data() {
          return {
            strapData: strapData,
            manufacturerOpen: false,
            modelOpen: false,
            sizeOpen: false,
            manufacturerSearch: '',
            modelSearch: '',
            sizeSearch: '',
            selectedManufacturer: '',
            selectedModel: '',
            selectedSize: '',
            manufacturerPlaceholder: mountPoint.getAttribute('data-manufacturer-placeholder') || 'Select manufacturer...',
            modelPlaceholder: mountPoint.getAttribute('data-model-placeholder') || 'Select model...',
            sizePlaceholder: mountPoint.getAttribute('data-size-placeholder') || 'Select size...',
            searchPlaceholder: mountPoint.getAttribute('data-search-placeholder') || 'Search...'
          };
        },
        computed: {
          manufacturers: function manufacturers() {
            var unique = _toConsumableArray(new Set(this.strapData.map(function (item) {
              return item.manufacturer;
            })));
            return unique.sort();
          },
          filteredManufacturers: function filteredManufacturers() {
            if (!this.manufacturerSearch) return this.manufacturers;
            var query = this.manufacturerSearch.toLowerCase();
            return this.manufacturers.filter(function (m) {
              return m.toLowerCase().includes(query);
            });
          },
          models: function models() {
            var _this4 = this;
            if (!this.selectedManufacturer) return [];
            var filtered = this.strapData.filter(function (item) {
              return item.manufacturer === _this4.selectedManufacturer;
            });
            var unique = _toConsumableArray(new Set(filtered.map(function (item) {
              return item.model;
            })));
            return unique.sort();
          },
          filteredModels: function filteredModels() {
            if (!this.modelSearch) return this.models;
            var query = this.modelSearch.toLowerCase();
            return this.models.filter(function (m) {
              return m.toLowerCase().includes(query);
            });
          },
          sizes: function sizes() {
            var _this5 = this;
            if (!this.selectedManufacturer || !this.selectedModel) return [];
            var filtered = this.strapData.filter(function (item) {
              return item.manufacturer === _this5.selectedManufacturer && item.model === _this5.selectedModel;
            });
            var unique = _toConsumableArray(new Set(filtered.map(function (item) {
              return item.size;
            })));
            var getCmValue = function getCmValue(val) {
              var match = val.match(/\((\d+)/);
              return match ? parseInt(match[1], 10) : Infinity;
            };
            return unique.sort(function (a, b) {
              return getCmValue(a) - getCmValue(b);
            });
          },
          filteredSizes: function filteredSizes() {
            if (!this.sizeSearch) return this.sizes;
            var query = this.sizeSearch.toLowerCase();
            return this.sizes.filter(function (s) {
              return s.toLowerCase().includes(query);
            });
          },
          manufacturerDisplay: function manufacturerDisplay() {
            return this.selectedManufacturer || this.manufacturerPlaceholder;
          },
          modelDisplay: function modelDisplay() {
            return this.selectedModel || this.modelPlaceholder;
          },
          sizeDisplay: function sizeDisplay() {
            return this.selectedSize || this.sizePlaceholder;
          },
          isComplete: function isComplete() {
            return this.selectedManufacturer && this.selectedModel && this.selectedSize;
          }
        },
        methods: {
          closeAllDropdowns: function closeAllDropdowns() {
            this.manufacturerOpen = false;
            this.modelOpen = false;
            this.sizeOpen = false;
          },
          toggleManufacturer: function toggleManufacturer() {
            var _this6 = this;
            var wasOpen = this.manufacturerOpen;
            this.closeAllDropdowns();
            this.manufacturerOpen = !wasOpen;
            if (this.manufacturerOpen) {
              this.$nextTick(function () {
                var _this6$$refs$manufact;
                (_this6$$refs$manufact = _this6.$refs.manufacturerSearch) === null || _this6$$refs$manufact === void 0 || _this6$$refs$manufact.focus();
              });
            }
          },
          toggleModel: function toggleModel() {
            var _this7 = this;
            if (!this.selectedManufacturer) return;
            var wasOpen = this.modelOpen;
            this.closeAllDropdowns();
            this.modelOpen = !wasOpen;
            if (this.modelOpen) {
              this.$nextTick(function () {
                var _this7$$refs$modelSea;
                (_this7$$refs$modelSea = _this7.$refs.modelSearch) === null || _this7$$refs$modelSea === void 0 || _this7$$refs$modelSea.focus();
              });
            }
          },
          toggleSize: function toggleSize() {
            var _this8 = this;
            if (!this.selectedModel) return;
            var wasOpen = this.sizeOpen;
            this.closeAllDropdowns();
            this.sizeOpen = !wasOpen;
            if (this.sizeOpen) {
              this.$nextTick(function () {
                var _this8$$refs$sizeSear;
                (_this8$$refs$sizeSear = _this8.$refs.sizeSearch) === null || _this8$$refs$sizeSear === void 0 || _this8$$refs$sizeSear.focus();
              });
            }
          },
          selectManufacturer: function selectManufacturer(manufacturer) {
            this.selectedManufacturer = manufacturer;
            this.selectedModel = '';
            this.selectedSize = '';
            this.manufacturerOpen = false;
            this.manufacturerSearch = '';
            this.emitChange();
          },
          selectModel: function selectModel(model) {
            this.selectedModel = model;
            this.selectedSize = '';
            this.modelOpen = false;
            this.modelSearch = '';
            this.emitChange();
          },
          selectSize: function selectSize(size) {
            this.selectedSize = size;
            this.sizeOpen = false;
            this.sizeSearch = '';
            this.emitChange();
          },
          emitChange: function emitChange() {
            mountPoint.dispatchEvent(new CustomEvent('watch-strap-selector:change', {
              detail: {
                manufacturer: this.selectedManufacturer,
                model: this.selectedModel,
                size: this.selectedSize,
                isComplete: this.isComplete
              },
              bubbles: true
            }));
          }
        }
      });
      WatchStrapApp.config.compilerOptions.delimiters = ['${', '}'];
      try {
        this.vueInstance = WatchStrapApp.mount(mountPoint);
      } catch (error) {
        console.error('Error mounting WatchStrapSelector:', error);
        this.disconnectedCallback();
      }
    }
  }]);
}(_wrapNativeSuper(HTMLElement));
customElements.define('watch-strap-selector', WatchStrapSelector);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
/* harmony import */ var _components_vue_search_select__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(525);
/* harmony import */ var _components_vue_search_select__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_components_vue_search_select__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_watch_strap_selector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913);
/* harmony import */ var _components_watch_strap_selector__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_components_watch_strap_selector__WEBPACK_IMPORTED_MODULE_1__);




}();
/******/ })()
;